import Swiper, { Navigation, Lazy } from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class MiniCartRecommendations extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-miniCartRecommendations',
      prevArrow: '.js-miniCartRecommendationsPrev',
      nextArrow: '.js-miniCartRecommendationsNext',
      swiperSlide: '.js-slide',
      blockTitle: '.js-blockTitle',
      blockMax: '.js-blockMax',
      blockMin: '.js-blockMin',
      cartTotal: '.js-cartTotal',
      cartItem: '.CartItem',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
      $swiperSlides: this.$getAll(this.refs.swiperSlide),
      $blockTitles: this.$getAll(this.refs.blockTitle),
      $cartTotal: document.querySelector(this.refs.cartTotal),
      $cartItems: document.querySelectorAll(this.refs.cartItem),
    };

    this.state = {
      swiper: null,
      mountCartItemsTotals: 'mountcarttotals',
      numSteps: 0,
      currentStep: 0,
      stepIndices: {},
      stepConstraints: [],
    };

    this.mount();
    this.init();
  }

  mount() {
    const { state } = this;
    super.mount();

    this.setOnCustomEvent(state.mountCartItemsTotals, this.updateSlider);
  }

  init() {
    this.initSlider();
    this.initSteps();
    this.updateSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Lazy],
      preloadImages: false,
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: false,
      threshold: 5,
      navigation: {
        prevEl: dom.$prevArrow,
        nextEl: dom.$nextArrow,
      },
      lazy: {
        loadOnTransitionStart: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }

  initSteps() {
    const { dom, state } = this;
    state.numSteps = dom.$blockTitles.length;
    let min = 0;
    let max = 7;

    Array.from(dom.$blockTitles).forEach((block) => {
      const index = block.getAttribute('data-step-index');
      const cartMin = block.getAttribute('data-step-min');
      const cartMax = block.getAttribute('data-step-max');
      state.stepConstraints[index] = { index, cartMin, cartMax };
      state.stepIndices[index] = { min, max };
      min = max;
      max += 6;
    });

    if (state.numSteps === 1) {
      max = dom.$swiperSlides.length - 1;
      min = 0;
      state.stepIndices[0] = { min, max };
    }
  }

  productInCart(id) {
    const cartItems = document.querySelectorAll(this.refs.cartItem);
    const product = Array.from(cartItems).filter((item) => item.getAttribute('data-product-id') === id);
    return product.length > 0;
  }

  updateSlider() {
    const { dom, state } = this;
    const cartTotal = parseInt(dom.$cartTotal.innerHTML.replace(/[\r\n\s$,+]/gm, ''), 10);
    /* eslint-disable-next-line */
    const [currentStep] = state.stepConstraints.filter((step) => cartTotal < step.cartMax && cartTotal >= step.cartMin);

    if (!currentStep) {
      dom.$component.classList.add('hide');
      return;
    }

    Array.from(dom.$blockTitles).forEach((title) => {
      if (title.getAttribute('data-step-index') === currentStep.index) {
        title.classList.remove('hide');
      } else {
        title.classList.add('hide');
      }
    });

    Array.from(dom.$swiperSlides).forEach((slide, index) => {
      const { min, max } = state.stepIndices[currentStep.index];
      const id = slide.getAttribute('data-product-id');
      if (index >= min && index < max && !this.productInCart(id)) {
        // if slide is not already in the cart
        slide.classList.remove('hide');
      } else {
        slide.classList.add('hide');
      }
    });

    const numHiddenSlides = this.$getAll(`${this.refs.swiperSlide}.hide`).length;
    if (numHiddenSlides === dom.$swiperSlides.length) {
      dom.$component.classList.add('hide');
    } else {
      dom.$component.classList.remove('hide');
    }
  }
}
